export const ImpressionsBarData = [
  { dataKey: "Impressions" },
  { dataKey: "TG Impressions" },
];

export const ImpressionsBarDataMapping = [
  { valueKey: "otsTotal", label: "Impressions" },
  { valueKey: "tgOtsTotal", label: "TG Impressions" },
];

export const ReachBarData = [{ dataKey: "Reach" }, { dataKey: "TG Reach" }];

export const ReachBarDataMapping = [
  { valueKey: "reach", label: "Reach" },
  { valueKey: "tgReach", label: "TG Reach" },
];

export const GenderBarData = [
  { dataKey: "Male", type: "monotone" },
  { dataKey: "Female", type: "monotone" },
];

export const GenderBarDataMapping = [
  { valueKey: "male", label: "Male" },
  { valueKey: "female", label: "Female" },
];

export const AgeSplitBarData = [
  { dataKey: "Below-18" },
  { dataKey: "18-34" },
  { dataKey: "35-44" },
  { dataKey: "45-Above" },
];
